/**
 * @fileoverview Zod schema for Sales Pipeline's Edit Prospect form (PATCH /sales/prospects/{id}).
 * @description The same five sections and rules as the New Prospect form, minus the owner (it
 * changes only through Assign Owner). The registration number and bank type are part of the form so
 * they travel back unchanged, but the form shows them read-only. Messages reuse the New Prospect
 * form's translation keys, translated at the display call site.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { createProspectFormSchema } from './create-prospect-form.schema'

import type { z } from 'zod'

/** @description The Edit Prospect form's rules. */
export const editProspectDetailsFormSchema = createProspectFormSchema.omit({
  proposedOwnerUserId: true,
})

/** @description The Edit Prospect form's values. */
export type EditProspectDetailsFormValues = z.infer<typeof editProspectDetailsFormSchema>
